import React, { useEffect, useRef, useState } from 'react';
import { useDimension } from 'lb-components';
import { DimensionContext, DimensionWrapper, Icon } from 'lb-components';
import { LeaderChatSprite, WorldCupIcon, BellIcon } from '../assets/icons';
import AppMob from './AppMob';
import {
  UseUser,
  UseEvent,
  UseHeader,
  UsePhoneVerification,
  UseAlert,
  UseLang,
  UseFooter,
  UseNotification,
  UseNavigation,
} from 'lb-store/src/hooks';
import AppWeb from './AppWeb';
import { Helpers, i18n, Toast, Api, useTranslation } from 'lb-store';
import _ from 'lodash';
import moment from 'moment';
import UseVerification from 'lb-store/src/hooks/useVerification';
import UseBottomBar from 'lb-store/src/hooks/useBottomBar';

let showMessage = true;
let showFeeMessage = true;
let showSmsAddsMessage = true;

window.server_time_interval = null;
const App = () => {
  const langHook = UseLang();
  const otpRef = useRef();
  const { readUserNotification, readFeeChangeMessage, readSmsAddsMessage } =
    UseNotification();
  //const [load, setLoad] = useState(false);
  const { ready, i18n } = useTranslation();
  const ev = UseEvent();
  const phoneVerification = UsePhoneVerification();
  const Alert = UseAlert();
  const nav = UseNavigation();
  const verification = UseVerification();
  const bottomBar = UseBottomBar();
  const {
    keepAlive,
    updateBalance,
    setUserData,
    setUserBalance,
    updateNotifications,
    setUserNotifications,
    User,
    Alive,
  } = UseUser();

  const pingMessages = () => {
    Api.User.Toasts({ timestamp: Date.now() }).then((res) => {
      if (res.status && res.data?.status === 1) {
        _.forEach(res.data?.data, (message) => {
          const difference = moment(message.date).diff(
            moment.unix(window.server_time),
            'milliseconds'
          );
          //TODO: categorize by type
          const isPromo = message?.title?.indexOf('{gatamasheba}') > -1;

          const show =
            message.date &&
            difference >= 0 &&
            difference <= 120000 &&
            (message.test === 0 ||
              window.location.host.includes('reactive.lider-bet.com'));

          if (show)
            setTimeout(() => {
              Toast.show({
                type: 'info',
                content: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: '1.5rem',
                    }}
                  >
                    <Icon
                      Icon={isPromo ? WorldCupIcon : BellIcon}
                      classname={'toast-info-icon'}
                    />
                    <div style={{ flex: 1 }}>
                      <h1>
                        {isPromo
                          ? message.title.replace('{gatamasheba}', '')
                          : message.title}
                      </h1>
                      <p>{message?.text?.replace('&nbsp;', ' ')}</p>
                    </div>
                    {isPromo && (
                      <div className={'live-container'}>
                        <span className={'text'}>LIVE</span>
                        <span className={'circle'} />
                      </div>
                    )}
                  </div>
                ),
                autoClose: 40000,
                hideProgressBar: true,
                className: 'custom-toast'.concat(isPromo ? ' world-cup' : ''),
                position: 'bottom-right',
                onClick: () => {
                  if (message.url) nav.navigate(message.url);
                },
              });
            }, difference);
        });
      }
    });
  };

  const headerHook = UseHeader();
  const footerCheck = UseFooter();
  const dimension = useDimension();
  useEffect(() => {
    window.open_deposit = function () {
      if (['md', 'chitovic'].includes(dimension.size)) {
        bottomBar.Open({ route: 'deposit' });
      } else nav.navigate('/'.concat(i18n.language, '/user/deposit'));
    };
  }, [dimension.size, i18n.language]);
  useEffect(() => {
    const AliveTimeout = setInterval(() => {
      Alive();
    }, 300000);
    headerHook.check();
    footerCheck.check();
    //langHook.setLang().then((r) => setLoad(true));

    // import gtag scripts
    /*(function () {
      if (!!window.dataLayer) return;

      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-J0MD23RLQ4';
      script.async = true;
      document.body.appendChild(script);

      window.dataLayer = window.dataLayer || [];

      function gtag() {
        window.dataLayer.push(arguments);
      }

      gtag('js', new Date());

      gtag('config', 'G-J0MD23RLQ4');
    })();*/

    if (!window.changeLanguageHead) {
      window.changeLanguageHead = async function (lang) {
        //first update server, then local i18n language
        try {
          await keepAlive(null, lang);
        } finally {
          i18n.changeLanguage(lang);
        }
      };
    }
    if (!window.updateBalance) {
      window.updateBalance = function () {
        updateBalance().finally();
      };
    }
    if (!window.isLogged) {
      window.isLogged = function () {
        return User.isLogged;
      };
    }
    if (!window.User) {
      window.User = User;
    }
    if (!window.updateUserNotifications) {
      window.updateUserNotifications = function () {
        updateNotifications().finally();
      };
    }
    //otp autofill for android
    keepAlive(null, i18n.language).then((res) => {
      if (res.data.mobile_verified === 'no') {
        phoneVerification.open({
          onSuccess: () => {
            Alert.open({ message: 'თქვენი ნომერი ვერიფიცირებულია' });
          },
        });
      }
      window.server_time = res?.data?.server_time;
      window.server_time_interval = setInterval(() => {
        window.server_time += 1;
      }, 1000);
      pingMessages();
    });
    //updateBalance().finally();
    updateNotifications().finally();
    const user = ev.subscribe('user', (data) => {
      setUserData(data);
      //console.log();

      if (_.size(data?.data?.notification) > 0 && nav.isMainPage()) {
        if (data?.data?.notification?.img_url) {
          Alert.open({
            actionLabel: 'წავიკითხე',
            containerStyle: 'notification-modal',
            footer: false,
            message: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                }}
              >
                <div
                  onClick={() => {
                    readUserNotification(data?.data?.notification?.id).finally(
                      () => {
                        if (data?.data?.notification?.redirect_url) {
                          window.location.href =
                            data?.data?.notification?.redirect_url;
                        }
                      }
                    );
                  }}
                  className={'notification-image'}
                  style={{
                    backgroundImage: `url(${data?.data?.notification?.img_url})`,
                    backgroundSize: 'cover',
                    aspectRatio: 2,
                  }}
                />

                <div
                  style={{
                    display: `flex`,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    backgroundColor: `#fec93f`,
                    padding: `1.6rem 2rem`,
                  }}
                >
                  <div
                    style={{
                      color: `black`,
                      fontFamily: ' lbet-mt-regular',
                      fontWeight: 'bold',
                      fontSize: `1.6rem`,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data?.data?.notification?.title,
                    }}
                  />
                  <div
                    style={{
                      color: `black`,
                      fontSize: `1.4rem`,
                      textAlign: `start`,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data?.data?.notification?.text,
                    }}
                  />
                </div>
              </div>
            ),
            onSuccess: ({ cancel }) => {
              readUserNotification(data?.data?.notification?.id).then(() =>
                cancel()
              );
            },
            onCancel: () => {
              readUserNotification(data?.data?.notification?.id).finally();
            },
          });
        } else {
          Alert.open({
            actionLabel: 'წავიკითხე',
            header: (
              <h3 style={{ color: `var(--bs-blue-gray)` }}>
                {data?.data?.notification?.title}
              </h3>
            ),
            message: (
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.data?.notification?.text,
                }}
              />
            ),
            onSuccess: ({ cancel }) => {
              readUserNotification(data?.data?.notification?.id).then(() =>
                cancel()
              );
            },
          });
        }
      }

      //if(data?.data?.reVerify && data?.data?.reVerify==1 ){
      if (
        showMessage &&
        data?.data?.reVerify &&
        data?.data?.reVerify == 1 &&
        window.localStorage.getItem('showVerificationBanner') === 'on'
      ) {
        showMessage = false;
        if (nav.isMainPage()) {
          Alert.open({
            actionLabel: 'ვერიფიკაცია',
            header: (
              <div style={{ color: 'white', fontFamily: 'lbet-mt-regular' }}>
                {i18n.t('ვერიფიკაცია')}
              </div>
            ),

            message: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: `1.6rem 2rem`,
                    fontSize: '1.6rem',
                    fontWeight: 'bold',
                  }}
                >
                  {i18n.t('ვერიფიკაციის ბონუსი')}
                </div>
              </div>
            ),
            onSuccess: ({ cancel }) => {
              verification.open({
                onSuccess: () => {
                  Alert.open({
                    message: i18n.t(
                      'დოკუმენტები ატვირთულია მიმდინარეობს ვერიფიკაცია ვერიფიცაკიის შესახებ შეტყობინებას მიიღებთ SMS-ით'
                    ),
                  });
                  cancel();
                },
              });
            },
            onCancel: () => {
              console.log('cancel');
            },
          });
          window.localStorage.setItem('showVerificationBanner', 'off');
        }
      }

      // fee change
      if (
        showFeeMessage &&
        data?.data?.notifications_all &&
        _.size(data?.data?.notifications_all) > 0 &&
        window.localStorage.getItem('showFeeMessage') === 'on'
      ) {
        showFeeMessage = false;
        if (nav.isMainPage()) {
          //console.log('showFeeMessage', showFeeMessage, data?.data);
          Alert.open({
            actionLabel: 'წავიკითხე',
            header: (
              <div style={{ color: 'white', fontFamily: 'lbet-mt-regular' }}>
                {i18n.t('attention')}
              </div>
            ),

            message: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: `1.6rem 2rem`,
                    fontSize: '1.6rem',
                    fontWeight: 'bold',
                  }}
                  dangerouslySetInnerHTML={{ __html: i18n.t('feeChange') }}
                />
              </div>
            ),
            onSuccess: ({ cancel }) => {
              readFeeChangeMessage(data?.data?.notifications_all[0]?.id).then(
                () => cancel()
              );
            },
            onCancel: () => {},
          });
          window.localStorage.setItem('showFeeMessage', 'off');
        }
      }

      // sms_adds_status
      if (
        data?.data?.sms_adds_status === -1 &&
        window.localStorage.getItem('showSmsAddsMessage') === 'on'
      ) {
        showSmsAddsMessage = false;
        //if (1) {
        //console.log('showFeeMessage', showFeeMessage, data?.data);
        Alert.open({
          actionLabel: 'ვეთანხმები',
          cancelLabel: 'უარყოფა',
          containerStyle: 'sms-adds-notification-modal',
          /*header: (
              <div style={{ color: 'white', fontFamily: 'lbet-mt-regular' }}>
                {i18n.t('smsAddsMessageTitle')}
              </div>
          ),*/
          footerComponent: ({ cancel }) => (
            <a
              className='sms_adds_message'
              onClick={() => cancel()}
              style={{
                color: `#bebebe`,
                display: `flex`,
                //justifyContent: 'flex-center',
                alignItems: 'center',
                justifyContent: 'center',
                //padding: `1.6rem 2rem`,
                padding: `0 0 2rem 0`,
                fontSize: '1.6rem',
                fontWeight: 'bold',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              {i18n.t('მკითხე მოგვიანებით')}
            </a>
          ),
          message: (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  display: `flex`,
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  padding: `1.6rem 2rem`,
                  fontSize: '1.7rem',
                  //fontWeight: 'bold',
                  fontFamily: 'lbet-nus-regular',
                  color: '#e7e7e7',
                  cursor: 'text',
                }}
                dangerouslySetInnerHTML={{
                  __html: i18n.t('smsAddsMessageText'),
                }}
              />
              <a
                target={'_blank'}
                href={`/${i18n.language}/rules?id=255&sub_id=283`}
                style={{
                  color: `#bebebe`,
                  display: `flex`,
                  flexDirection: 'column',
                  justifyContent: 'flex-center',
                  alignItems: 'flex-center',
                  padding: `0 2rem`,
                  fontSize: '1.6rem',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                dangerouslySetInnerHTML={{ __html: i18n.t('smsAddsKonfText') }}
              />
            </div>
          ),
          onSuccess: ({ cancel }) => {
            readSmsAddsMessage(1).then(() => cancel());
          },
          onCancel: () => {},
          onReject: ({ cancel }) => {
            readSmsAddsMessage(0).then(() => {
              cancel();
            });
          },
        });
        window.localStorage.setItem('showSmsAddsMessage', 'off');
        //}
      }
    });

    const balance = ev.subscribe('balance', (data) => setUserBalance(data));
    const notifications = ev.subscribe('notifications', (data) =>
      setUserNotifications(data)
    );
    const refreshBalance = ev.subscribe('update-balance', () => {
      updateBalance(true).finally();
    });

    const messagePinger = setInterval(() => {
      //dismiss old messages
      pingMessages();
    }, 120000);

    return () => {
      clearInterval(AliveTimeout);
      clearInterval(messagePinger);
      if (window.server_time_interval) {
        clearInterval(window.server_time_interval);
      }
      user.unsubscribe();
      balance.unsubscribe();
      notifications.unsubscribe();
      refreshBalance.unsubscribe();
    };
  }, []);

  useEffect(() => {
    window.User = User;
  }, [User]);

  return ready ? (
    Helpers.isMobile() ? (
      <>
        <input
          type='text'
          id='otp-input'
          ref={otpRef}
          style={{ display: 'none' }}
        />
        <AppMob />
      </>
    ) : (
      <DimensionContext.Provider value={dimension}>
        <DimensionWrapper show={['chitovic', 'md']}>
          <AppMob />
        </DimensionWrapper>
        <DimensionWrapper hidden={['chitovic', 'md']}>
          <AppWeb />
        </DimensionWrapper>
      </DimensionContext.Provider>
    )
  ) : null;
};

export default App;
